import { API_BASE } from 'shared/constants/Api'

export const OPEN_PAYMENTS_PAYMENT = `${API_BASE}/api/v2/integrations/openpayments/payment/`
export const OPEN_PAYMENTS_PAYMENT_VALIDATE = `${API_BASE}/api/v2/integrations/openpayments/payment/validate/`
export const OPEN_PAYMENTS_INVALIDATE = `${API_BASE}/api/v2/integrations/openpayments/payment/bank_accounts/invalidate/`
